import {assert, getPlatform} from "@prosay/common"
import {useAsyncEffect} from "@prosay/components"
import {getLogger} from "@prosay/logging"
import {Notifications} from "expo"
import * as Permissions from "expo-permissions"
import {useState} from "react"
import * as handlers from "./handlers"
import {NotificationListenerParam} from "./types"

const logger = getLogger(__filename)

const setupListener = () => {
    const subscription = Notifications.addListener(
        (notification: NotificationListenerParam) => {
            const handler = handlers[notification.data.type]
            assert(
                handler,
                `No handler found for notification type ${notification.data.type}`,
            )

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            handler(notification as any)
        },
    )
    logger.info`Added notification listener`
    return () => {
        subscription.remove()
        logger.info`Removed notification listener`
    }
}

const setupPermissions = async () => {
    logger.debug`Asking for notification permissions...`
    const {status, ...data} = await Permissions.askAsync(
        Permissions.NOTIFICATIONS,
    )
    logger.debug`Got the following response from permissions: ${{
        status,
        ...data,
    }}`

    assert(
        status === "granted",
        `We need notification permissions! Expected status to be "granted" but "${status}"`,
    )
}

/* eslint-disable react-hooks/rules-of-hooks */
export const useNotifications = () => {
    if (getPlatform() === "web") {
        logger.warn`Web notifications are currently not supported. Ignornig useNotifications.`
        return true
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [ready, setReady] = useState(false)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useAsyncEffect(async () => {
        try {
            await setupPermissions()
        } finally {
            setReady(true)
        }
        return setupListener()
    }, [setReady])

    return ready
}
/* eslint-enable react-hooks/rules-of-hooks */
